/**
 * Whether the invoice API returned an actual invoice.
 *
 * For an order that has not been invoiced, GET /api/invoice?orderId= answers {"invoice": {}} (an empty
 * object, not null). The tab used to treat any object as an invoice; once it added due_amount to it
 * (PGSS-5306) the empty object stopped looking empty, the tab rendered an invoice with no fields and
 * crashed reading bank_details. An empty object means "no invoice".
 */
export const hasInvoice = (invoice) =>
  Boolean(invoice) && typeof invoice === 'object' && Object.keys(invoice).length > 0;
